import { render, staticRenderFns } from "./AllergiesTemplate.vue?vue&type=template&id=2414dc46"
import script from "./AllergiesTemplate.vue?vue&type=script&lang=js"
export * from "./AllergiesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports